import { render } from "./ProcessoVendasModal.vue?vue&type=template&id=b0b792ca&scoped=true&ts=true"
import script from "./ProcessoVendasModal.vue?vue&type=script&lang=ts"
export * from "./ProcessoVendasModal.vue?vue&type=script&lang=ts"

import "./ProcessoVendasModal.vue?vue&type=style&index=0&id=b0b792ca&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0b792ca"]])

export default __exports__